import React from 'react'
import {
  MarkerClustererProps as GoogleMapsMarkerClustererProps,
  MarkerClusterer as GoogleMapsMarkerClusterer,
} from '@react-google-maps/api'

export interface MarkerClustererProps extends GoogleMapsMarkerClustererProps {}

export const MarkerClusterer = ({ options = {}, ...restProps }: MarkerClustererProps) => {
  const _options: MarkerClustererProps['options'] = {
    ...options,
    styles: options?.styles || [
      {
        width: 19,
        height: 24,
        url: 'https://i.imgur.com/Tj3qvzt.png',
        textColor: 'white',
        textSize: 10,
      },
      {
        width: 29,
        height: 36,
        url: 'https://i.imgur.com/oCDm0tR.png',
        textColor: 'white',
        textSize: 16,
      },
      {
        width: 38,
        height: 48,
        url: 'https://i.imgur.com/ulG8dqP.png',
        textColor: 'white',
        textSize: 20,
      },
    ],
  }

  return <GoogleMapsMarkerClusterer options={_options} {...restProps} />
}

export default MarkerClusterer
